import { PerPage } from "helpers/system-config";
import APIManager from "modules/common/apiManager";
import { CustomDropdown } from "modules/common/components";
import {
  ActionButtons,
  Alert,
  ButtonCommonTheme,
  ControlLabel,
  DataWithLoader,
  DataWrapperClass,
  FormControl,
  ImportFile,
  ModalTrigger,
  ReportPagination,
  SeachForm,
  SettingDropdownMenu,
  Table,
  Wrapper,
  confirm,
  ResponsiveHideComponent,
} from "modules/theme";
import { isAccess } from "modules/common/utils";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { MenuItem } from "react-bootstrap";
import { connect } from "react-redux";
import { modalType } from "../../../../../helpers/dotenv";
import { globalStateSelector } from "../../../../../store/selector";
import CannedMessagesAddEdit from "./CannedMessageAddEdit";
import styled from "styled-components";
import { debounce } from "../../../../../helpers/common";

class CannedMessages extends Component {
  constructor(props) {
    super(props);
    this.mAPI = new APIManager();
    this.moduleName = "Canned Messages";
    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);
    this.onPaginationChange = this.onPaginationChange.bind(this);
    this.onPerPageChooser = this.onPerPageChooser.bind(this);
    this.clearSearchField = this.clearSearchField.bind(this);
    this.state = {
      listData: [],
      loading: false,
      editData: null,
      showHide: false,
      modalType: modalType,
      total: 0,
      currentPage: 1,
      perPageCount: PerPage,
      search: "",
      MasterChecked: false,
      SingleChecked: false,
      SelectedList: [],
      searchValue: "",
      tagList: [],
    };
  }

  onMasterCheck(e) {
    const checked = e.target.checked;
    this.state.listData.forEach((message) => (message.selected = checked));
    this.setState({
      MasterChecked: checked,
      SelectedList: checked ? this.state.listData : [],
    });
  }

  clearSearchField() {
    this.setState({ searchValue: "" });
  }

  onItemCheck(e, item) {
    const checked = e.target.checked;
    const target = this.state.listData.find(
      (message) => message._id === item._id
    );
    if (target) {
      target.selected = checked;
    }
    const MasterChecked =
      this.state.listData.reduce(
        (count, message) => (message.selected ? count + 1 : count),
        0
      ) === this.state.listData.length;
    this.setState({
      MasterChecked,
      SelectedList: this.state.listData.filter((message) => message.selected),
    });
  }

  deleteMessages(ids) {
    this.mAPI.sendPostAPI(
      `canned-message/`,
      { ids },
      (data) => {
        this.setState({ currentPage: 1, MasterChecked: false });
        this.getList(
          this.state.currentPage,
          this.state.perPageCount,
          this.state.search
        );
        if (data && data.message) {
          Alert.success(data.message);
        } else {
          Alert.success(
            `${this.moduleName}${
              data.modifiedCount > 1 ? "s" : ""
            } deleted successfully.`
          );
        }
      },
      (errorCode, data) => {
        Alert.error(`errorCode : ${data}`);
      },
      `private`,
      {},
      "DELETE"
    );
  }

  deleteAllData = () => {
    this.deleteMessages(this.state.SelectedList.map((m) => m._id));
  };

  debouncedSearch = debounce(() => {
    this.getList(
      1,
      this.state.perPageCount,
      encodeURIComponent(this.state.searchValue)
    );
  }, 500);

  search = (e) => {
    this.setState({
      currentPage: 1,
      searchValue: e.target.value.trim() ? e.target.value : "",
    });
    this.debouncedSearch();
  };

  componentDidMount() {
    this.getList(
      this.state.currentPage,
      this.state.perPageCount,
      this.state.search
    );
  }

  getList(page = 1, perPage = "", searchText = "") {
    var that = this;
    this.setState({ loading: true });
    perPage = perPage || this.state.perPageCount;
    this.mAPI.sendGetAPI(
      `canned-message?limit=${perPage}&page_no=${page}&search=${searchText}&orderBy=create_at&order=DESC`,
      (data) => {
        this.setState({ loading: false });

        if (data && data.data) {
          that.setState({
            listData: data.data.map((i) => ({
              ...i,
              selected: false,
            })),
            total: data.count || 0,
            SelectedList: [],
            MasterChecked: false,
          });
        } else {
          that.setState({ listData: [], total: 0 });
        }
      },
      (error, data) => {
        if (data) {
          Alert.error(` ${data.message}`);
        } else {
          Alert.error(`${error}`);
        }
      }
    );
  }

  onPaginationChange(page) {
    this.setState({ currentPage: page, MasterChecked: false });
    this.getList(page, "", this.state.search);
  }

  onPerPageChooser(perPage) {
    this.setState({
      currentPage: 1,
      perPageCount: perPage,
      search: "",
      searchValue: "",
    });
    this.setState({});
    this.getList(1, perPage, this.state.search);
  }

  openModal(data) {
    if (data) {
      this.setState({ showHide: true, editData: data });
    } else {
      this.setState({ showHide: true, editData: undefined });
    }
  }

  closeModal(isUpdated) {
    this.setState({ showHide: false });
    if (isUpdated) {
      this.getList(this.state.currentPage, this.state.perPageCount);
    }
  }

  deleteMessage(id) {
    this.deleteMessages([id]);
  }

  renderActionBar() {
    const ImportTrigger = ({ onClick }) => {
      if (isAccess(this.props.access, "add")) {
        return (
          <ResponsiveHideComponent
            hideOnSmallScreen={this.state.SelectedList.length > 0}
          >
            <ButtonCommonTheme type="add" addOnClick={onClick} />
          </ResponsiveHideComponent>
        );
      }
      return null;
    };
    return (
      <span style={{ display: "flex", whiteSpace: "nowrap" }}>
        <ModalTrigger
          title="Canned Message"
          trigger={<ImportTrigger />}
          size="md"
          showHide={this.state.showHide}
          closeModal={this.closeModal}
          openModal={this.openModal}
          dialogClassName={this.state.modalType}
        >
          <CannedMessagesAddEdit
            size="small"
            editData={this.state.editData}
            modalType={this.state.modalType}
            closeModal={this.closeModal}
            clearSearchField={this.clearSearchField}
          />
        </ModalTrigger>
      </span>
    );
  }

  render() {
    const { __ } = this.context;
    const breadcrumb = [
      { title: __("Settings"), link: "/settings" },
      { title: __("Canned Messages"), link: "/settings/canned-messages" },
    ];

    const mainContent = (
      <DataWrapperClass className="tableFixHeadSecondary">
        <Table whiteSpace="nowrap" bordered hover>
          <thead>
            <tr>
              {isAccess(this.props.access, "delete") && (
                <th onClick={this.onClick}>
                  <FormControl
                    componentClass="checkbox"
                    checked={this.state.MasterChecked}
                    onChange={(e) => this.onMasterCheck(e)}
                  />
                </th>
              )}
              <th>{__("Message")}</th>
              <th>{__("Tags")}</th>
              <th>{__("Actions")}</th>
            </tr>
          </thead>
          <tbody id="canned-message">
            {this.state.listData.map((message, index) => (
              <tr key={message._id}>
                {isAccess(this.props.access, "delete") && (
                  <td onClick={this.onClick}>
                    <FormControl
                      componentClass="checkbox"
                      checked={message.selected}
                      onChange={(e) => this.onItemCheck(e, message)}
                    />
                  </td>
                )}
                <td className="max-w-xl overflow-x-hidden truncate">
                  {message.message}
                </td>
                <td>
                  <RenderTags tags={message.tags} />
                </td>
                <td>
                  <ActionButtons>
                    <ButtonCommonTheme
                      type="edit"
                      editOnClick={() => this.openModal(message)}
                    />
                    {isAccess(this.props.access, "delete") && (
                      <CustomDropdown
                        index={index}
                        totalLength={this.state.listData.length || 0}
                      >
                        <MenuItem
                          style={{ marginLeft: "0px" }}
                          onClick={() =>
                            confirm().then(() => {
                              this.deleteMessage(message._id);
                            })
                          }
                        >
                          Delete
                        </MenuItem>
                      </CustomDropdown>
                    )}
                  </ActionButtons>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </DataWrapperClass>
    );

    return (
      <div className="heightClass">
        <DataWrapperClass>
          <Wrapper
            header={<Wrapper.Header breadcrumb={breadcrumb} />}
            heading={<ControlLabel>Canned Messages</ControlLabel>}
            actionBar={
              <Wrapper.ActionBar
                left={
                  <div style={{ display: "flex" }}>
                    <SeachForm className="mr-5">
                      <FormControl
                        type="text"
                        placeholder={"Search Here"}
                        onChange={this.search}
                        value={this.state.searchValue}
                        autoFocus={false}
                      />
                      <span class="material-symbols-outlined">search</span>
                    </SeachForm>
                    {this.state.SelectedList.length > 0 && (
                      <ButtonCommonTheme
                        type="deleteAll"
                        checkboxDeleteOnClick={() =>
                          confirm().then(() => this.deleteAllData())
                        }
                      />
                    )}
                  </div>
                }
                right={this.renderActionBar()}
              />
            }
            footer={
              <ReportPagination
                count={this.state.total}
                onPaginationChange={this.onPaginationChange}
                onPerPageChooser={this.onPerPageChooser}
                currentPage={this.state.currentPage}
                perPage={this.state.perPageCount}
              />
            }
            leftSidebar={<SettingDropdownMenu />}
            showLeftSideBar={true}
            content={
              <div>
                <DataWithLoader
                  data={mainContent}
                  loading={this.state.loading}
                  size={this.state.listData.length}
                  count={this.state.listData.length}
                  emptyText="Sorry..! No Canned Messages Found"
                  emptyImage="/images/cannedempty.png"
                />
              </div>
            }
          />
        </DataWrapperClass>
      </div>
    );
  }
}

const Badge = styled.span`
  padding: 0.25rem 0.7rem;
  background-color: rgb(92, 122, 255);
  color: white;
  border-radius: 2rem;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
`;

function RenderTags({ tags }) {
  if (!Array.isArray(tags) || tags.length === 0) {
    return "-";
  } else {
    return (
      <div className="inline-flex gap-2 items-center">
        {tags.slice(0, 2).map((tag) => (
          <Badge>{tag}</Badge>
        ))}
        {tags.length > 2 && <Badge>+{tags.length - 2}</Badge>}
      </div>
    );
  }
}

CannedMessages.contextTypes = {
  __: PropTypes.func,
};
const stateToProps = (state) => ({
  access: globalStateSelector.getPermission(state, "canned-messages"),
});

export default connect(stateToProps)(CannedMessages);



// WEBPACK FOOTER //
// src/modules/screens/settings/CannedMessages/components/CannedMessages.jsx